import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';

const PANEL_ID = 'poster-editor-item-layout-panel';

export default function PosterEditorItemLayoutModal(): ReactElement<any> {
  const height = '156px';
  const maxWidth = '800px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_ITEM_LAYOUT_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      bottomSheetCloseThreshold={130}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="poster-editor-item-layout-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorItemLayoutModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_ITEM_LAYOUT_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
